import { Routes } from '@angular/router';

export const reportsRoutes: Routes = [
    {
        path: 'reports',
        children: [
            {
                path: 'annual-deregistration-report',
                loadComponent: () => import('./annual-deregistration-report/annual-deregistration-report.component').then(c => c.AnnualDeregistrationReportComponent),
                data: { title: 'Annual Deregistration Report' }
            },
            {
                path: 'omc-weekly-reports',
                redirectTo: '/mis/demand-forecasts/omc-friday-stocks',
                pathMatch: 'full'
            },
            {
                path: 'omc-weekly-reports/:uuid',
                redirectTo: '/mis/demand-forecasts/omc-friday-stocks/:uuid'
            },
            {
                path: 'terminal-daily-usage-reports',
                redirectTo: '/mis/demand-forecasts/daily-terminal-stocks',
                pathMatch: 'full'
            },
            {
                path: 'terminal-daily-usage-reports/:uuid',
                redirectTo: '/mis/demand-forecasts/daily-terminal-stocks/:uuid'
            },

            {
                path: 'omc-registrations-report',
                loadComponent: () => import('./omc-registrations-report/omc-registrations-report.component').then(c => c.OmcRegistrationsReportComponent),
                data: { title: 'OMC Registrations Report' }
            },
            {
                path: 'terminal-tanks-report',
                loadComponent: () => import('./terminal-tanks-report/terminal-tanks-report.component').then(c => c.TerminalTanksReportComponent),
                data: { title: 'Terminal Tanks Report' }
            },
            {
                path: 'friday-terminal-stock-report',
                loadComponent: () => import('./terminal-stock-report/terminal-stock-report.component').then(c => c.TerminalStockReportComponent),
                data: { title: 'Friday Terminal Stock Report' }
            },
            {
                path: 'omc-friday-stock-report',
                loadComponent: () => import('./omc-friday-stock-report/omc-friday-stock-report.component').then(c => c.OmcFridayStockReportComponent),
                data: { title: 'OMC Friday Stock Report' }
            },
            {
                path: 'omc-friday-stock-report-transit',
                loadComponent: () => import('./omc-friday-stock-report-transit/omc-friday-stock-report-transit.component').then(c => c.OmcFridayStockReportTransitComponent),
                data: { title: 'OMC Friday Stock Report - Transit' }
            },
            {
                path: 'daily-terminal-stock-report',
                loadComponent: () => import('./omc-terminal-usage-report/omc-terminal-usage-report.component').then(c => c.OmcTerminalUsageReportComponent),
                data: { title: 'Daily Terminal Stock Report' }
            },
            {
                path: 'terminals-ullage-report',
                loadComponent: () => import('./terminals-ullage-report/terminals-ullage-report.component').then(c => c.TerminalsUllageReportComponent),
                data: { title: 'Terminals Ullage Report' }
            },
            {
                path: 'appendix-demand-submission-report',
                loadComponent: () => import('./appendix-demand-submission-report/appendix-demand-submission-report.component').then(c => c.AppendixDemandSubmissionReportComponent),
                data: { title: 'Appendix B Demand Submission Report' }
            },
            {
                path: 'receivable-aging-analysis-report',
                loadComponent: () => import('./receivable-aging-analysis-report/receivable-aging-analysis-report.component').then(c => c.ReceivableAgingAnalysisReportComponent),
                data: { title: 'Receivable Aging Analysis Report' }
            },
            {
                path: 'omc-product-allocation-report',
                loadComponent: () => import('./omc-product-allocation-report/omc-product-allocation-report.component').then(c => c.OmcProductAllocationReportComponent),
                data: { title: 'OMC Product Allocation Report' }
            },
            {
                path: 'prequalified-suppliers-report',
                loadComponent: () => import('./prequalified-suppliers-report/prequalified-suppliers-report.component').then(c => c.PrequalifiedSuppliersReportComponent),
                data: { title: 'Prequalified Suppliers Report' }
            },
            {
                path: 'bank-guarantee-report',
                loadComponent: () => import('./bank-guarantee-report/bank-guarantee-report.component').then(c => c.BankGuaranteeReportComponent),
                data: { title: 'Bank Guarantee Report' }
            },
            {
                path: 'tankers-line-up-report',
                loadComponent: () => import('./tanker-lineup-report/tanker-lineup-report.component').then(c => c.TankerLineupReportComponent),
                data: { title: 'Tankers Line Up Report' }
            }
        ]
    }
];

